import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() { return ["selfServiceable", "public"]; }

  // One invariant, enforced from both ends: self serviceable implies public. Each handler clicks
  // the other box rather than assigning `checked`, so the other handler runs in turn and finds
  // nothing left to do.
  syncFromSelfServiceable() {
    if (this.selfServiceableTarget.checked && !this.publicTarget.checked) {
      this.publicTarget.click();
    }
  }

  syncFromPublic() {
    if (!this.publicTarget.checked && this.selfServiceableTarget.checked) {
      this.selfServiceableTarget.click();
    }
  }
}
